(($, Drupal, drupalSettings) => {
  Drupal.behaviors.field_fact_sources = {
    attach(context) {
      const fieldFactSources = once(
        "field_fact_sources",
        ".field-fact-sources",
        context
      );
      if (fieldFactSources.length === 1) {
        $(".field-fact-sources").accordion({
          active: false,
          heightStyle: "content",
          collapsible: true,
          event: "click",
          animate: {
            easing: "linear",
            duration: 200,
          },
          icons: {
            header: "fa fa-caret-down",
            activeHeader: "fa fa-caret-down",
          },
          create(event, ui) {
            const icon = event.target.querySelector(".ui-icon");
            console.log(icon.classList);
            icon.classList.remove("ui-icon");
            icon.classList.add("poopoopoo");
          },
        });
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
